import UIActions from "../actions/UIActions";

var APIError = {
  handle: function (err) {
    var handled = false;
    var status = err.status;

    switch (status) {
      case 401: //Not Authorized Need To Login Again
        UIActions.showLogin();
        handled = true;
        break;
      case null:
        UIActions.showOffline();
        handled = true;
        break;
    }

    return handled;
  },
};

export default APIError;
